import React from "react";
import { Gamepad2, X, Linkedin, Send, Instagram, Youtube, Facebook, Mail, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
export default function StoreFooter() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="6902" id="footer" className="dark bg-[#0A0E14] text-[#F4EFE6] py-16 px-6 md:px-8 border-t border-[#B8922A]/20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
          {}
          <div className="flex flex-col items-start space-y-6">
            <Link to="/HomePage" className="block">
              <span className="text-2xl font-sans font-bold tracking-tighter text-[#F4EFE6]">
                MACARONI <span className="text-[#B8922A]">CAPITAL</span>
              </span>
            </Link>
            <p className="text-[#F4EFE6]/60 text-base font-serif leading-relaxed max-w-xs italic">
              Systematic Trading, Simplified. AI-assisted trading education for the modern market technician.
            </p>
            
            <div className="flex flex-col space-y-3 text-sm font-serif text-[#F4EFE6]/60">
              <div className="flex items-center gap-3">
                <MapPin className="w-4 h-4 text-[#B8922A]" />
                <span>San Francisco, California</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#B8922A]" />
                <Link to="mailto:support@macaronicapital.io" className="hover:text-[#B8922A] transition-colors">
                  support@macaronicapital.io
                </Link>
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col items-start md:items-center">
            <div className="flex flex-col space-y-6 w-full max-w-xs">
              <h3 className="text-sm font-sans font-bold tracking-widest text-[#F4EFE6] uppercase">Platform</h3>
              <nav className="flex flex-col space-y-3">
                {[{
                label: "How It Works",
                path: "/HowItWorksPage"
              }, {
                label: "The Planner",
                path: "/ThePlannerPage"
              }, {
                label: "Caddie",
                path: "/CaddiePage"
              }, {
                label: "Connect",
                path: "/ConnectPage"
              }, {
                label: "Legal",
                path: "#"
              }].map((item, i) => <Link key={i} data-index={i} to={item.path} className="text-[#F4EFE6]/60 hover:text-[#B8922A] transition-colors text-base font-serif w-fit">
                    {item.label}
                  </Link>)}
              </nav>
            </div>
          </div>

          {}
          <div className="flex flex-col items-start md:items-end">
            <div className="flex flex-col space-y-6 w-full max-w-xs items-start md:items-end">
              <h3 className="text-sm font-sans font-bold tracking-widest text-[#F4EFE6] w-full md:text-right uppercase">Follow</h3>
              
              <Button className="w-full md:w-auto bg-[#B8922A] hover:bg-[#D4AE52] text-[#0A0E14] border-none rounded-none shadow-none font-sans font-bold tracking-widest uppercase transition-all duration-300 cursor-pointer" size="lg" asChild>
                <Link to="/ConnectPage">
                  <Gamepad2 className="w-5 h-5 mr-2" />
                  Start Your Plan
                </Link>
              </Button>

              <div className="flex items-center gap-4 mt-4">
                {[{
                icon: Youtube,
                label: "YouTube",
                to: "https://youtube.com/@MacaroniCapital"
              }, {
                icon: X,
                label: "X",
                to: "https://x.com/MacaroniCapital"
              }, {
                icon: Facebook,
                label: "Facebook",
                to: "https://facebook.com/@MacaroniCapital"
              }, {
                icon: Instagram,
                label: "Instagram",
                to: "https://instagram.com/@MacaroniCapital"
              }, {
                icon: Linkedin,
                label: "LinkedIn",
                to: "#"
              }, {
                icon: Send,
                label: "Substack",
                to: "https://macaronicapital.substack.com"
              }].map((social, i) => <Link key={i} data-index={i} to={social.to} className="bg-transparent border border-[#B8922A] p-2.5 rounded-none hover:bg-[#B8922A] hover:text-[#0A0E14] text-[#B8922A] transition-all duration-300 group" aria-label={social.label}>
                    <social.icon className="w-5 h-5" />
                  </Link>)}
              </div>
            </div>
          </div>
        </div>

        <Separator className="bg-[#B8922A]/30 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-[11px] font-serif text-[#F4EFE6]/40 text-center md:text-left">
          <p>&copy; 2026 Macaroni Capital LLC · macaronicapital.io</p>
          <div className="flex items-center gap-4">
            <span className="hidden md:inline-block w-px h-3 bg-[#B8922A]/30"></span>
            <p className="flex items-center gap-1 uppercase tracking-tighter">
              Macaroni Capital is an educational platform. <span className="text-[#F4EFE6]/60 font-medium">Nothing on this site constitutes investment advice.</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}